import {Component, inject, OnDestroy, OnInit, signal} from '@angular/core';
import {ManufacturerRest} from '../../service/ManufacturerRest';
import {OidcSecurityService} from 'angular-auth-oidc-client';
import {Router} from '@angular/router';
import {interval, map, Subscription, take} from 'rxjs';
import {SsoUser} from '../../app.constants';
import {filter} from 'rxjs/operators';
import { AlertDialogService } from '../../shared/commons/dialog/alert-dialog/alert-dialog.service';

@Component({
  selector: 'app-welcome',
  standalone: true,
  imports: [],
  templateUrl: './welcome.component.html',
  styleUrl: './welcome.component.scss'
})
export class WelcomeComponent implements OnInit, OnDestroy {
  private oidcSecurityService = inject(OidcSecurityService)
  public router: Router = inject(Router);
  countdown: number = 6;
  countdownSubscription: Subscription | undefined;
  isCountdownActive = signal(false)
  manufacturerRest = inject(ManufacturerRest)
  userData: any;
  alertDialogService = inject(AlertDialogService)

  ngOnInit(): void {
    this.oidcSecurityService.userData$
      .pipe(map(e => e.userData))
      .pipe(filter(e => !!e))
      .subscribe(e => {
        console.log(e)
        this.userData = e as SsoUser
        if (this.userData?.resource_access?.['qrtraces']?.roles.includes('user')) {
          this.manufacturerRest.findBySsoUserId().subscribe(e => {
            console.log("login as ", e?.businessType)
            if (!e) {
              this.startCountdown();
            }else{
              if((!e?.juristicId && !e?.pid) || !e?.contractUser?.telephoneNo){
                if(this.userData?.resource_access?.['qrtraces']?.roles.includes("user_admin")){
                  this.alertDialogService.open({content:'กรุณาตรวจสอบข้อมูลผู้ประกอบการ เนื่องจากข้อมูลของท่านยังไม่ครบถ้วนสมบรูณ์',}).subscribe({
                    next:()=>{
                      this.router.navigate(['manufacturer'])
                    }
                  })
                }
                else{
                  this.alertDialogService.open({content:'กรุณาตรวจสอบข้อมูลผู้ประกอบการ เนื่องจากข้อมูลของท่านยังไม่ครบถ้วนสมบรูณ์ โปรดติดต่อผู้ใช้งานบทบาท ADMIN เพื่อดำเนินการอัปเดตข้อมูลให้ครบถ้วน',})
                }
              }
            }
          })
        }
      })
  }

  startCountdown() {
    this.isCountdownActive.set(true)
    this.countdownSubscription = interval(1000)
      .pipe(take(this.countdown))
      .subscribe(() => {
        this.countdown--;
        if (this.countdown === 0) {
          this.router.navigate(['manufacturer']);
        }
      });
  }

  ngOnDestroy(): void {
    if (this.countdownSubscription) {
      this.countdownSubscription.unsubscribe();
    }
  }

}
